var _path, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconDocRealEstate = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5 67C52.0015 67 67 52.0015 67 33.5C67 14.9985 52.0015 0 33.5 0C14.9985 0 0 14.9985 0 33.5C0 52.0015 14.9985 67 33.5 67Z",
    fill: "#BCD9C9"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 67,
    height: 67
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.5 67C52.0015 67 67 52.0015 67 33.5C67 14.9985 52.0015 0 33.5 0C14.9985 0 0 14.9985 0 33.5C0 52.0015 14.9985 67 33.5 67Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 17,
    width: 47,
    height: 31
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.57153 17.9465H55.0358V47.8573H9.57153V17.9465Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.3199 47.8573H12.2881C10.7875 47.8573 9.57153 46.568 9.57153 44.9762V20.8276C9.57153 19.2364 10.7875 17.9465 12.2881 17.9465H52.3199C53.8198 17.9465 55.0358 19.2364 55.0358 20.8276V44.9762C55.0358 46.568 53.8198 47.8573 52.3199 47.8573Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 38.2856,
    y: 35.8928,
    width: 11.9643,
    height: 2.39286,
    rx: 1.19643,
    fill: "#727D79"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.2856,
    y: 31.1072,
    width: 11.9643,
    height: 2.39286,
    rx: 1.19643,
    fill: "#727D79"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.2856,
    y: 26.3215,
    width: 11.9643,
    height: 2.39286,
    rx: 1.19643,
    fill: "#727D79"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.125,
    y: 17.5,
    width: 48.75,
    height: 30.8036,
    rx: 3.25,
    stroke: "#727D79",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9459 28.7142H13.7258C13.4714 28.7142 13.2453 28.5317 13.1888 28.2884C13.104 28.0146 13.2171 27.7408 13.4432 27.5888L23.0532 21.6269C23.2228 21.5052 23.4489 21.5052 23.6185 21.6269L33.2286 27.5583C33.4547 27.7104 33.5395 27.9842 33.483 28.258C33.4264 28.5317 33.2003 28.7142 32.9459 28.7142ZM30.826 27.4966L23.3359 22.8427L15.8457 27.4966H30.826Z",
    fill: "#FF8B22"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0759 29.9102H16.344C16.0405 29.9102 15.7921 30.1584 15.7921 30.4618V38.3783H14.9091C14.6055 38.3783 14.3572 38.6265 14.3572 38.9299C14.3572 39.2333 14.6055 39.4816 14.9091 39.4816H30.5553C30.8588 39.4816 31.1072 39.2333 31.1072 38.9299C31.1072 38.6265 30.8588 38.3783 30.5553 38.3783H29.6723V30.4618C29.6723 30.1584 29.4239 29.9102 29.1204 29.9102H26.3885C26.0849 29.9102 25.8366 30.1584 25.8366 30.4618V38.3783H19.6278V30.4618C19.6278 30.1308 19.3794 29.9102 19.0759 29.9102ZM16.8958 31.0127H18.5238V38.3775H16.8958V31.0127ZM28.5959 31.0127H26.9678V38.3775H28.5959V31.0127Z",
    fill: "#FF8B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9349 40.678H13.7256C13.4149 40.678 13.1606 40.9472 13.1606 41.2762C13.1606 41.6052 13.4149 41.8744 13.7256 41.8744H32.9349C33.2457 41.8744 33.4999 41.6052 33.4999 41.2762C33.4999 40.9472 33.2457 40.678 32.9349 40.678Z",
    fill: "#FF8B22"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconDocRealEstate);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-doc-real-estate.78bd8507d1418c6b6db2a1315c431c99.svg";